import React from 'react';
import { NavLink } from "react-router-dom";

import imgLogo from '../img/hackaton-3d-menu.svg';

export default function Menu() { 
    
  const verCargaProject = true;

  const linkCarga = verCargaProject ? <NavLink to="/cargaproyectos">Enviar proyecto</NavLink> : null;

  const linkCargaRes = verCargaProject ? <NavLink to="/cargaproyectos" activeClassName="activeMenuItem" className="list-group-item">Enviar proyecto</NavLink> : null;

  return (
      <React.Fragment>
            <div className="menu-home">
                <NavLink exact to="/">Home</NavLink>
                <NavLink exact to="/acercade">Acerca de</NavLink>
                {/* <NavLink to="/licencias">Sobre las licencias</NavLink> */}
                {linkCarga}
                <NavLink to="/contacto">Contacto</NavLink>
            </div>

          <div id="dw-p1" className="bmd-layout-drawer bg-faded">    
            <div className="navbar-brand"><img src={imgLogo} className="img-fluid" alt="HACKATON 3D" /></div>   
            <ul className="list-group menuLat">
                <NavLink exact to="/" activeClassName="activeMenuItem" className="list-group-item">Home</NavLink>
                <NavLink exact to="/acercade" activeClassName="activeMenuItem" className="list-group-item">Acerca de</NavLink>
                {/* <NavLink to="/licencias" activeClassName="activeMenuItem" className="list-group-item">Sobre las licencias</NavLink> */}
                {linkCargaRes}
                <NavLink to="/contacto" activeClassName="activeMenuItem" className="list-group-item">Contacto</NavLink>
            </ul>
        </div>
      </React.Fragment>
    
  );
}